"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.HELPER = exports.LABEL_HEADER = exports.LABEL_CONTAINER = exports.LABEL = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    LABEL = (0, _cxs["default"])({
  margin: 0,
  marginBottom: "10px",
  display: "block"
});

exports.LABEL = LABEL;

var LABEL_CONTAINER = function LABEL_CONTAINER(a) {
  var b = a.notFullWidth;
  return (0, _cxs["default"])({
    textAlign: "left",
    width: b ? void 0 : "100%",
    display: "block"
  });
};

exports.LABEL_CONTAINER = LABEL_CONTAINER;
var LABEL_HEADER = (0, _cxs["default"])({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
});
exports.LABEL_HEADER = LABEL_HEADER;
var HELPER = (0, _cxs["default"])({
  margin: 0,
  marginTop: "10px",
  display: "block"
});
exports.HELPER = HELPER;